import React, { Component, Fragment } from "react";
import config from "./../../common/config";
import app from "./../../common/app";
import core from "./../../common/core";
import Routes from "./../routes";
// import Loader from './../loader';
import ErrorBoundary from "./../errorBoundary";

class Wrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      goAhead: false,
      // isShowCookiePopup: false,
    };
  }

  showHidePopup = () => {
    const self = this;
    let nodePopup = null;
    const objPopup = self.props.objPopup;
    if (objPopup) {
      var clonedElementWithMoreProps = React.cloneElement(
        objPopup.component ? objPopup.component : <div />,
        { isShow: objPopup.isShow }
      );
      nodePopup = clonedElementWithMoreProps;
    }
    return nodePopup;
  };

  componentDidMount = () => {
    this.setState({
      goAhead: true,
    });
    // let cookie = app.getLoginCookie();
    // if (cookie && cookie.IsRegister != 1) {
    //   this.setState({
    //     isShowCookiePopup: true,
    //   });
    // } else {
    //   this.setState({
    //     isShowCookiePopup: false,
    //   });
    // }
  };

  // resgisterUser = () => {
  //   let data = {
  //     OptType: 2,
  //     PlatformId: 1,
  //     UserId: 0,
  //     SocialId: "",
  //     ClientId: 1,
  //     FullName: "",
  //     EmailId: "",
  //     PhoneNo: 0,
  //     CountryCode: "",
  //   };
  //   app.postLogin(data, (resp) => {
  //     if (resp && resp.Meta && resp.Meta.RetVal === 1) {
  //       this.setState({
  //         isShowCookiePopup: false,
  //       });
  //     } else {
  //       console.log(resp.Meta.RetVal);
  //     }
  //   });
  // // };

  // showHideCookiePopup = () => {
  //   const resp = (
  //     <div className="si-popup__wrap si-fade bg-dark in">
  //       <div className="si-popup__container si-popup__container--gdp">
  //         <div className="si-popup__body">
  //           <p>
  //             We use cookies to improve our website, so you have the best
  //             browsing experience. We also collect information about your use of
  //             our site and any other information you provide during registration
  //             on the site.
  //           </p>
  //           <p>
  //             {" "}
  //             <b>
  //               By clicking on 'OK' below, you accept our terms and conditions.
  //             </b>{" "}
  //             Further, in case you are logging in to the contest page, you agree
  //             to their terms &amp; conditions as well.
  //           </p>
  //         </div>
  //         <div className="si-popup__btn">
  //           <div
  //             className="si-btn si-btn__primary"
  //             onClick={(e) => {
  //               e.stopPropagation();
  //               this.resgisterUser();
  //             }}
  //           >
  //             <span>OK</span>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  //   return resp;
  // };

  render() {
    const self = this;
    const { showHidePopup, props, state, /* showHideCookiePopup */ } = self;
    const { goAhead, /* isShowCookiePopup */ } = state;

    const nodeLoader = (
      <div className="si-pg-loader-mainWrap">
        <div className="si-pg-loader">
          <span></span>
          <span></span>
        </div>
      </div>
    );
    let nodeBody = goAhead ? (
      <Routes {...props} nodeLoader={nodeLoader} />
    ) : (
      nodeLoader
    );
    const nodePopup = showHidePopup();
    // const nodeCookiePopup = showHideCookiePopup();
    return (
      <ErrorBoundary>
        <div className="si-main" id="si-main">
          {nodeBody}
          {nodePopup}
          {/* {isShowCookiePopup ? nodeCookiePopup : null} */}
        </div>
      </ErrorBoundary>
    );
  }
}

export default Wrapper;
